import styled, { css } from 'styled-components'

import { FlexCentered, RowFlex } from 'components/common/genericStyles'
import { isIPad } from 'utils/device'

import { tabDesktopBreakpoint } from '../constants'

export const Wrapper = styled.div`
    ${FlexCentered}
    padding: 8px 16px;
    border-radius: 8px;
    background: ${({ isTimerOver }) =>
        isTimerOver ? 'rgba(0, 0, 0, 0.3)' : '#f6d47a'};
    position: absolute;
    left: 6.66vw;
    top: 3.33vh;
    height: 32px;
    z-index: 4;
    ${props =>
        props.$isWaiting &&
        css`
            left: auto;
            right: 6.66vw;
            & > span {
                margin-left: 15px;
            }
        `}

    @media only screen and (min-width: ${tabDesktopBreakpoint}px) {
        background: rgba(0, 0, 0, 0.12);
        left: 1.66vw;;
        top: 2.83vh;
        z-index: 0;
        height: auto;
        ${props =>
            props.$isWaiting &&
            css`
                left: ${isIPad ? '11vw' : '8vw'};
                right: auto;
                & > span {
                    margin-left: 15px;
                }
            `}
    }
`

export const textStyles = css`
    font-size: 14px;
    @media only screen and (min-width: ${tabDesktopBreakpoint}px) {
        font-size: 16px;
        color: #fff;
    }
`

export const LoaderWrapper = styled.div`
    width: 35px;
    ${FlexCentered}
`

export const UnattemptedStudents = {
    Wrapper: styled.div`
        width: inherit;
        ${RowFlex}
        justify-content: flex-start;
        align-items: center;
    `,
    Icon: styled.div`
        ${FlexCentered}
        background: #f7f8fa;
        box-shadow: 1.8125px 1.8125px 0px rgba(0, 0, 0, 0.75);
        border-radius: 15.8594px;
        margin-right: 10px;

        & > img {
            width: 24px;
            height: 24px;
        }
    `,
}
